import { render, staticRenderFns } from "./page-paiGong-view.vue?vue&type=template&id=1394b920&scoped=true&"
import script from "./page-paiGong-view.vue?vue&type=script&lang=js&"
export * from "./page-paiGong-view.vue?vue&type=script&lang=js&"
import style0 from "./page-paiGong-view.vue?vue&type=style&index=0&id=1394b920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394b920",
  null
  
)

component.options.__file = "page-paiGong-view.vue"
export default component.exports